import { times } from "lodash";
import PreA1_ComicStory from './PreA1/ComicStory';
import A1_ComicStory from './A1/ComicStory';
import A2_ComicStory from './A2/ComicStory';
import Dialogue from './Shared/Dialogue';
import FactualTopic from './PreA1/FactualTopic';
import InformationPosters, { createPostersImageItem, createPostersTextItem } from './Shared/InformationPosters';
import NoteTaking from './Shared/NoteTaking';
import MeetAndGreet from './Shared/MeetAndGreet';
import MinimalDifferences from './PreA1/MinimalDifferences';
import OnlineMessages, {
    createOnlineMessagesImageItem,
    createOnlineMessagesTextItem,
    createOnlineMessagesWritingItem
} from './Shared/OnlineMessages';
import QuestionsAboutYou from './Shared/QuestionsAboutYou';
import SceneBuilder from './PreA1/SceneBuilder';
import SceneCreation from './Shared/SceneCreation';
import SceneHighlighting from './PreA1/SceneHighlighting';
import Shop from './PreA1/Shop';
import A1_Spelling from './A1/Spelling';
import A2_Spelling from './A2/Spelling';
import PreA1_Spelling from './PreA1/Spelling';
import VoiceMessages from "./A1/VoiceMessages";
import SpotTheDifference from "./A1/SpotTheDifference";
import A1_PictureEditing from './A1/PictureEditing';
import A2_PictureEditing from './A2/PictureEditing';
import PreA1_PictureEditing from './PreA1/PictureEditing';
import { createSpeakingPlacementItem, createSpeakingSimpleItem } from "./sharedLogic/speakingItemCreators";
import MultipleMatching from "./A1/MultipleMatching";
import TellTheStory from "./A1/TellTheStory";
import GapFillStory from "@dyl/task-types/A1/GapFillStory";
import ProductiveWriting from "./A2/ProductiveWriting";
import PostersAndMessages from "./A2/PostersAndMessages";
import PersonalIntroductions from "./A2/PersonalIntroductions";
import InformationText from "./A1/InformationText";
import InformationText_A2 from "./A2/InformationText";

const TaskTypes = {
    'Pre-A1': [
        PreA1_ComicStory,
        Dialogue({ itemCount: 3 }),
        FactualTopic,
        InformationPosters({
            itemTemplateFunc: () => [
                createPostersImageItem({ isExample: true }),
                ...times(5, createPostersImageItem)
            ]
        }),
        NoteTaking(),
        MeetAndGreet,
        MinimalDifferences,
        OnlineMessages(),
        PreA1_PictureEditing,
        QuestionsAboutYou({ disableTargets: false }),
        SceneBuilder,
        SceneCreation, // Story Scene
        SceneHighlighting,
        Shop,
        PreA1_Spelling,
    ],
    'A1': [
        MeetAndGreet,
        QuestionsAboutYou({
            disableTargets: true,
            itemTemplateFunc: () => [
                createSpeakingPlacementItem(),
                ...times(3, createSpeakingSimpleItem),
            ]
        }),
        VoiceMessages,
        SpotTheDifference,
        Dialogue({ itemCount: 4 }),
        SceneCreation, // Story Scene
        A1_PictureEditing,
        MultipleMatching,
        OnlineMessages({
            itemTemplateFunc: () => [
                createOnlineMessagesImageItem({ isExample: true }),
                ...times(2, createOnlineMessagesImageItem),
                createOnlineMessagesTextItem(),
                createOnlineMessagesWritingItem({ hasRubric: true }),
                createOnlineMessagesWritingItem(),
            ]
        }),
        NoteTaking('A1'),
        InformationText,
        A1_Spelling,
        TellTheStory,
        InformationPosters({
            itemTemplateFunc: () => [
                createPostersImageItem({ isExample: true }),
                ...times(2, createPostersImageItem),
                ...times(3, createPostersTextItem),
            ]
        }),
        GapFillStory,
        A1_ComicStory,
    ],
    'A2': [
        MeetAndGreet,
        QuestionsAboutYou({
            disableTargets: true,
            itemTemplateFunc: () => [
                createSpeakingPlacementItem(),
                ...times(3, createSpeakingSimpleItem),
            ]
        }),
        VoiceMessages,
        SpotTheDifference,
        Dialogue({ itemCount: 4 }),
        SceneCreation, // Story Scene
        A2_PictureEditing,
        MultipleMatching,
        OnlineMessages({
            itemTemplateFunc: () => [
                createOnlineMessagesImageItem({ isExample: true }),
                ...times(2, createOnlineMessagesImageItem),
                createOnlineMessagesTextItem(),
                createOnlineMessagesWritingItem({ hasRubric: true }),
                createOnlineMessagesWritingItem(),
            ]
        }),
        NoteTaking('A1'),
        A2_Spelling,
        TellTheStory,
        InformationPosters({
            itemTemplateFunc: () => [
                createPostersImageItem({ isExample: true }),
                ...times(2, createPostersImageItem),
                ...times(3, createPostersTextItem),
            ]
        }),
        GapFillStory,
        A2_ComicStory,
        ProductiveWriting,
        PostersAndMessages,
        PersonalIntroductions,
        InformationText_A2
    ],
};

export default TaskTypes;